import React, { useState, useEffect, Fragment } from 'react';
import { Row, Card, CardBody } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { gAPI_Promos_List } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CreatePromosForm from './components/forms/CreatePromosForm';
import UpdatePromosForm from './components/forms/UpdatePromosForm';
import TemplatePromoButton from './components/forms/TemplatePromoButton';

function Index({ propertyId, locale }) {
  const [promosList, setPromosList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    LoadData();
  }, [propertyId]);

  const LoadData = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Promos_List}/?propertyId=${propertyId}&status=all&languageCode=${locale}`,
    })
      .then(res => {
        setPromosList(res.data.promos);
        setLoading(false);
      })
      .catch(err => console.log('err', err));
  }

  if (loading) {
    return (
      <Card className="d-flex flex-row mb-3">
        <CardBody>
          <h4 style={{ textAlign: 'center' }}>Loading...</h4>
        </CardBody>
      </Card>
    );
  }

  return (
    <Fragment>
      <Row>
        <Colxx xxs="6" className="mb-2">
          <CreatePromosForm />
        </Colxx>
        <Colxx xxs="6" className="mb-2">
          <TemplatePromoButton LoadData={LoadData} />
        </Colxx>
      </Row>
      <Colxx xxs="12" className="mb-2 text-right">
        <strong><hr /></strong>
      </Colxx>
      <Row>
        {promosList.map((promo, index) => (
          <Colxx xxs="12" key={index}>
            <Card className="d-flex flex-row mb-3">
              <img
                alt="Thumbnail"
                src={
                  promo.images[0]
                    ? promo.images[0].url
                    : 'https://via.placeholder.com/250x150'
                }
                className="list-thumbnail responsive border-0"
              />
              <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                  <p className="mb-1  text-small w-15 w-sm-100">
                    <b>{promo.name}</b>
                  </p>
                  <p className="mb-1 text-muted text-small w-15 w-sm-100">
                    {promo.displayText}
                  </p>
                  <p className="mb-1 text-muted text-small w-15 w-sm-100">
                    {promo.displayFreeText}
                  </p>
                  <p className="mb-1 text-muted text-small w-15 w-sm-100">
                    {promo.conditions}
                  </p>
                  <p className="mb-1 text-muted text-small w-15 w-sm-100">
                    {promo.status}
                  </p>
                  <div className="w-15 w-sm-100">
                    <UpdatePromosForm id={promo.id} propertyId={propertyId} />
                  </div>
                </div>
              </div>
            </Card>
          </Colxx>
        ))}
      </Row>

    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
